import { render } from "./CldrError.vue?vue&type=template&id=3b57a0c2&scoped=true"
import script from "./CldrError.vue?vue&type=script&lang=js"
export * from "./CldrError.vue?vue&type=script&lang=js"

import "./CldrError.vue?vue&type=style&index=0&id=3b57a0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b57a0c2"]])

export default __exports__